import { useState } from 'react';
import * as S from './styles.ts';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from '@template/icons';

export type TAccordionItem = {
  title: string;
  titleIcon?: string;
  content: React.ReactNode;
};

export interface IAccordionInterface {
  items: TAccordionItem[];
  withArrow?: boolean;
  activeColor?: 'primary' | 'secondary' | 'default';
  defaultActiveIndex?: number;
  type?: 'exclusive' | 'inclusive';
  whiteBackground?: boolean;
}

const Accordion = ({
  items,
  withArrow = true,
  activeColor = 'default',
  defaultActiveIndex = 0,
  type = 'exclusive',
  whiteBackground = false,
}: IAccordionInterface) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(
    defaultActiveIndex
  );
  const [activeIndexes, setActiveIndexes] = useState<number[]>([]);

  const handleClick = (index: number) => {
    if (type === 'exclusive') {
      setActiveIndex(activeIndex === index ? null : index);
    } else {
      const newActiveIndexes = activeIndexes.includes(index)
        ? activeIndexes.filter((i) => i !== index)
        : [...activeIndexes, index];
      setActiveIndexes(newActiveIndexes);
    }
  };

  return (
    <S.AccordionContainer>
      {items.map((item, index) => {
        const active =
          type === 'exclusive'
            ? activeIndex === index
            : activeIndexes.includes(index);
        return (
          <S.AccordionItem key={index}>
            <S.AccordionTitle
              onClick={() => handleClick(index)}
              $activeColor={activeColor}
              $active={active}
              $whiteBackground={whiteBackground}
            >
              {item.title}
              {withArrow && (
                <S.ArrowContainer $expanded={active}>
                  <ChevronDown />
                </S.ArrowContainer>
              )}
            </S.AccordionTitle>
            <AnimatePresence>
              {active && (
                <S.AccordionContentWrapper
                  as={motion.div}
                  initial={{ height: 0 }}
                  animate={{
                    height: 'auto',
                  }}
                  exit={{ height: 0 }}
                >
                  <S.AccordionContent>{item.content}</S.AccordionContent>
                </S.AccordionContentWrapper>
              )}
            </AnimatePresence>
          </S.AccordionItem>
        );
      })}
    </S.AccordionContainer>
  );
};

export default Accordion;
